import React from "react"
import { type Role } from "src/gql/graphql"
import UserClock from "@myvp/todos/src/uat-time-travel/user-clock"
import { useUserSelector } from "src/hooks/use-user"

const PatientVirtualClock = (props: {
  studyId: string | null | undefined
  role: Role | undefined
  participantRelatedUserId: string | null | undefined
  children?: React.ReactNode
}) => {
  const studyRoleContext = React.useMemo(() => {
    if (props.studyId && props.role && props.participantRelatedUserId) {
      return {
        studyId: props.studyId,
        role: props.role,
        participantRelatedUserId: props.participantRelatedUserId,
      }
    } else {
      return undefined
    }
  }, [props.studyId, props.role, props.participantRelatedUserId])
  const virtualTimeEnabled = useUserSelector(
    (state) => state.getDoesAccountUseVirtualTime.virtualTimeAllowed
  )
  return (
    <UserClock
      virtualTimeDisabled={!virtualTimeEnabled}
      studyRoleContext={studyRoleContext}
    >
      {props.children}
    </UserClock>
  )
}

export default PatientVirtualClock
